import React, { useContext, useState } from "react";
import { get, isEmpty } from "lodash";
import { Form, Button, Col, Row } from "react-bootstrap";

import { CalculateLoanSourceSplit } from "../LoanRequestContainer/CalcuateLoanSourceSplit";
import { LoaderWrapper, SliderPanel, WarningModal } from "../../../components";
import {
  FLOW_TYPES,
  getAdvancedPathWithParam,
  getPathWithParam,
  LOAN_STATUS,
  MANAGE_CENSUS_ROUTES,
  MANAGE_DISTRIBUTION_ROUTES,
  MANAGE_TRANSACTION_ROUTES,
  modifyLoanOptions,
  ROUTES,
} from "../../../utils";
import { useRouterParams, useDeepEffect } from "../../../abstracts";
import {
  submitLoanRequestById,
  getEmployeeEligiblePlanLoans,
  getLoanSummaryById,
  rejectLoan,
  getAmortizationSchedule,
  getRepaymentSchedule,
} from "../../../services";
import { useHistory } from "react-router-dom";
import ManageDistributionLayout from "../../../components/ManageDistributionLayout/ManageDistributionLayout";
import { Formik } from "formik";
import { faTimes } from "@fortawesome/pro-solid-svg-icons";
import {
  appLayoutStore,
  globalToastInfo,
  manageDistributionStore,
  setWithdrawalRequestPageData,
} from "../../../contexts";
import { getPayrollFrequencies } from "../../../services";
import { calculateTotalNoOfInstallments } from "../../../utils";
import { useEffect } from "react";
import LoanSummarySlider from "./LoanSummarySlider";
import LoanSummaryDetails from "./LoanSummaryDetails";
import LoanModifySummary from "./LoanModifySummary";
import LoanSuspensionRequest from "../LoanSuspensionContainer/LoanSuspensionRequest";

const FieldInputCheck = (props) => {
  return <input {...props} />;
};

const LoanSummaryContainer = () => {
  const { state, dispatch } = useContext(manageDistributionStore);
  const filteredValues = get(state, "api.censusInformation", {});
  const { state: state2, dispatch: dispatch2 } = useContext(appLayoutStore);
  var today = new Date();
  const history = useHistory();
  const { flow, censusId, loanRequestId, fromPage } = useRouterParams();
  const loanDataFromState = get(state, "loanData");
  const [loanDataFromAPI, setLoanDataFromAPI] = useState({});
  const loanData = !isEmpty(loanDataFromState)
    ? loanDataFromState
    : loanDataFromAPI;
  {
    console.log("loanid", loanDataFromState, loanData);
  }

  const [planData, setPlanData] = useState({});
  const [responseLoading, setResponseLoading] = useState(false);
  const [loanSettingInfo, setLoanSettingInfo] = useState({});
  const [isConsentGiven, setIsConsentGiven] = useState(false);
  const [sourceSplit, setSourceSplit] = useState([]);
  const [sourceSplitData, setSourceSplitData] = useState([]);
  const [frequencyList, setFrequencyList] = useState([]);
  const [keyValue, setKeyValue] = useState(1);
  const [modifyFor, setModifyFor] = useState(null);
  const [showClose, setShowClose] = useState(false);
  const [modalVisible, setModalVisible] = useState(false);

  const tabChange = (key) => {
    setKeyValue(key);
  };

  function checkBox() {
    setIsConsentGiven(false);
    if (document.querySelector("#opt1:checked")) {
      setIsConsentGiven(true);
    }
  }

  useDeepEffect(() => {
    if (filteredValues?.companyId) {
      getPayrollFrequencies(filteredValues?.companyId)
        .then((response) => {
          setFrequencyList(response);
        })
        .catch((error) => {
          //Handle Error
        });
    }
  }, [filteredValues?.companyId]);

  useDeepEffect(
    () => {
      dispatch(
        setWithdrawalRequestPageData({
          formName: "censusId",
          fieldData: censusId,
        })
      );
    },
    [censusId],
    false
  );

  const payrollFrequencyId = loanDataFromState
    ? loanDataFromState?.repaymentFrequency
    : loanDataFromAPI?.repaymentFrequency;

  const frequency = frequencyList.find((_, i) => _.id === payrollFrequencyId)
    ?.name;

  const buttonsForInprogress = [
    {
      link: getAdvancedPathWithParam({
        path: ROUTES.LOAN_REQUEST,
        pathParam: [FLOW_TYPES.EDIT, censusId, loanDataFromState?.["loanId"]],
      }),
      label: "Back",
      variant: "secondary",
      type: "button",
    },
    {
      link: getAdvancedPathWithParam({
        path: MANAGE_CENSUS_ROUTES.EMPLOYEE_MANAGE_TRANSACTIONS,
        pathParam: [FLOW_TYPES.EDIT, censusId],
      }),
      label: "Cancel",
      variant: "secondary",
      type: "button",
    },
    {
      label: "Submit",
      variant: "primary",
      type: "submit",
    },
  ];

  const buttonsForSuspendedLoan = [
    {
      label: "Resume",
      variant: "secondary",
      type: "button",
      onClick: () => {
        setSliderOpen2(true);
      },
    },
  ];

  const buttonsForAwatingForApproval = [
    {
      link: getAdvancedPathWithParam({
        path: MANAGE_CENSUS_ROUTES.EMPLOYEE_MANAGE_TRANSACTIONS,
        pathParam: [FLOW_TYPES.EDIT, censusId],
      }),
      label: "",
      variant: "link",
      type: "button",
      icon: faTimes,
    },
  ];

  const buttonsForActiveLoan = [
    {
      label: "modify Loan",
      options: modifyLoanOptions.map((_) => {
        return _;
        // switch (_.value) {
        //   case 1: {
        //     if (!loanSettingInfo?.refinancingAllowed) {
        //       return (_ = {
        //         ..._,
        //         disabled: true,
        //         message: "Refinance is not allowed",
        //       });
        //     } else if (
        //       loanSettingInfo?.numberOfRefinancingAllowed &&
        //       loanData?.refinancingCount >=
        //         loanSettingInfo?.numberOfRefinancingAllowed
        //     ) {
        //       return (_ = {
        //         ..._,
        //         disabled: true,
        //         message: "The permitted refinancing limit has been reached",
        //       });
        //     }
        //     return (_ = { ..._, disabled: false });
        //   }
        //   case 2: {
        //     if (!loanSettingInfo?.loanReAmortizationAllowed) {
        //       return (_ = {
        //         ..._,
        //         disabled: true,
        //         message: "Reamortization is not allowed",
        //       });
        //     } else if (
        //       loanSettingInfo?.numberOfLoanReAmortizationsAllowed &&
        //       loanData?.reAmortizationCount >=
        //         loanSettingInfo?.numberOfLoanReAmortizationsAllowed
        //     ) {
        //       return (_ = {
        //         ..._,
        //         disabled: true,
        //         message: "The permitted reamortization limit has been reached",
        //       });
        //     }
        //     return (_ = { ..._, disabled: false });
        //   }
        //   default: {
        //     if (
        //       loanSettingInfo?.numberOfSuspensionsPerLoanAllowed &&
        //       loanSettingInfo?.numberOfSuspensionsPerLoanAllowed <=
        //         loanData?.suspensionCount
        //     )
        //       return (_ = {
        //         ..._,
        //         disabled: true,
        //         message: "Cannot exceed number of allowed suspensions per loan",
        //       });
        //     return (_ = { ..._, disabled: false });
        //   }
        // }
      }),
      isDropdown: true,
      variant: "secondary",
      onClick: (val) => {
        val == 1
          ? setModifyFor("loanRefinancing")
          : val == 2
          ? setModifyFor("loanReamortization")
          : setModifyFor("suspend");
        setSliderOpen2(!sliderOpen2);
      },
    },
  ];

  const buttonsForModifiedLoan = [
    {
      label: "Modify Loan",
      variant: "secondary",
      type: "button",
      disabled: true,
    },
    {
      label: "Delete Request",
      variant: "outline-danger",
      type: "button",
      onClick: () => {
        setModalVisible(true);
      },
    },
  ];

  const buttonsForApprovalFlow =
    fromPage == 5
      ? [
          {
            label: "Previous",
            variant: "secondary",
            type: "button",
            link: getPathWithParam({
              path: MANAGE_DISTRIBUTION_ROUTES.LOAN_REQUEST,
              pathParam: [flow, censusId, loanRequestId, fromPage],
            }),
          },
          {
            label: "Cancel",
            variant: "secondary",
            type: "button",
            link: getPathWithParam({
              path: MANAGE_TRANSACTION_ROUTES.DRAFT,
            }),
          },
          {
            label: "Submit",
            variant: "primary",
            type: "submit",
          },
        ]
      : [
          {
            label: "Cancel",
            variant: "secondary",
            type: "button",
            onClick: () =>
              history.push(
                getAdvancedPathWithParam({
                  path: MANAGE_TRANSACTION_ROUTES.PENDINGLOAN,
                })
              ),
          },
          {
            label: "Next",
            variant: "secondary",
            type: "button",
            onClick: () =>
              history.push(
                getAdvancedPathWithParam({
                  path: MANAGE_TRANSACTION_ROUTES.PENDINGLOAN,
                })
              ),
          },
        ];

  const [trigger, setTrigger] = useState(false);
  useEffect(() => {
    if (isEmpty(loanDataFromState) && loanRequestId) {
      setResponseLoading(true);
      getLoanSummaryById(loanRequestId)
        .then((loanResponse) => {
          if (loanResponse.isSuccessfull) {
            setLoanDataFromAPI(loanResponse["loanRequest"], () => {});
            getEmployeeEligiblePlanLoans(censusId)
              .then((planResponse) => {
                setResponseLoading(false);
                if (planResponse) {
                  var plan = planResponse["employeePlans"]?.find(
                    (plan) => plan.id == loanResponse["loanRequest"]["planId"]
                  );
                  var loanSetting = plan["loanSettings"].find(
                    (item, index) =>
                      item.masterLoanTypeId ==
                      loanResponse["loanRequest"]?.loanSettingId
                  );
                  setPlanData(plan);
                  var sourceBalances = CalculateLoanSourceSplit(
                    plan?.sourceBalances,
                    loanResponse["loanRequest"],
                    loanSetting,
                    loanResponse["loanRequest"]?.overnightDelivery
                  );
                  setSourceSplitData([
                    {
                      tabName: "Summary",
                      //totalRequestedAmount: 2000,
                      sourceDetails: getSplits(sourceBalances).map(
                        (_) => (_ = { name: _.head, amount: _.amount })
                      ),
                    },
                    ...sourceBalances,
                  ]);
                  setSourceSplit(getSplits(sourceBalances));

                  setLoanSettingInfo(
                    planResponse["employeePlans"]
                      ?.find(
                        (plan) =>
                          plan.id == loanResponse["loanRequest"]["planId"]
                      )
                      ?.loanSettings?.find(
                        (loanSetting) =>
                          loanSetting.id ==
                          loanResponse["loanRequest"]["loanSettingId"]
                      )
                  );
                }
              })
              .finally(() => {
                // setResponseLoading(false);
              });
          }
        })
        .finally(() => {
          setResponseLoading(false);
        });
    } else {
      setSourceSplitData([
        {
          tabName: "Summary",
          //totalRequestedAmount: 2000,
          sourceDetails: getSplits(state?.sourceSplit).map(
            (_) => (_ = { name: _.head, amount: _.amount })
          ),
        },
        ...state?.sourceSplit,
      ]);
      setSourceSplit(getSplits(state?.sourceSplit));
    }
  }, [trigger]);

  const getSplits = (sourceBalances) => {
    let final = [];
    sourceBalances?.map((source) => {
      let sourceInv = source.sourceInvestmentBalances?.map((inv) => {
        return {
          id: inv.investmentId,
          amount: inv.requestedAmount,
          name: inv.investmentName ?? "-",
        };
      });
      let list = {
        id: source.sourceId,
        head: source.sourceName,
        amount: source.requestedAmount,
        subHead: sourceInv,
      };
      final.push(list);
    });
    return final;
  };

  function getFileNameFromBlobPath(url) {
    return url?.split("/").pop().split("_")[0];
  }

  function getFileExtensionFromBlobPath(url) {
    return url
      ?.split("/")
      .pop()
      .split("_")[1]
      ?.slice(
        ((url.split("/").pop().split("_")[1].lastIndexOf(".") - 1) >>> 0) + 2
      );
  }
  const requestId = loanDataFromState?.["loanId"]
    ? loanDataFromState["loanId"]
    : loanRequestId;
  const onFormSubmit = (values) => {
    submitLoanRequestById(parseInt(requestId)).then((response) => {
      setResponseLoading(false);
      if (response.isSuccessfull) {
        // if (fromPage == 5) {
        dispatch2(
          globalToastInfo({
            showToast: true,
            toastMessage: "Loan Request submitted successfully",
          })
        );
        // }

        history.push(
          getAdvancedPathWithParam({
            path:
              fromPage == 5
                ? MANAGE_TRANSACTION_ROUTES.DRAFT
                : MANAGE_CENSUS_ROUTES.EMPLOYEE_MANAGE_TRANSACTIONS,
            pathParam: fromPage == 5 ? [] : [FLOW_TYPES.EDIT, censusId],
          })
        );
      }
    });
  };

  const [sliderOpen1, setSliderOpen1] = useState(false);
  const [sliderOpen2, setSliderOpen2] = useState(false);
  const [employeeImage, setEmployeeImage] = useState("");

  function calculateTotalFees() {
    if (!isEmpty(loanDataFromState)) {
      return (
        loanDataFromState?.loanFeeAmount +
        (loanDataFromState.paymentMethod == 1 ||
        loanDataFromState.paymentOption == 1
          ? loanDataFromState?.chequeFees
          : loanDataFromState?.eftFees)
      );
    } else {
      return (
        loanDataFromAPI?.loanFeeAmount +
        (loanDataFromAPI.paymentMethod == 1 ||
        loanDataFromAPI.paymentOption == 1
          ? loanDataFromAPI?.chequeFees
          : loanDataFromAPI?.eftFees)
      );
    }
  }

  function calculateNetAmount() {
    return loanDataFromState
      ? loanDataFromState.requestedAmount + calculateTotalFees()
      : loanDataFromAPI.requestedAmount + calculateTotalFees();
  }

  const paymentMethod = loanData?.paymentOption ?? loanData?.paymentMethod;
  const loanStatus = LOAN_STATUS[loanData?.loanStatus] ?? null;
  const [amortizationSchedule, setAmortizationSchedule] = useState();
  const [repaymentSchedule, setRepaymentSchedule] = useState([]);

  useDeepEffect(() => {
    if (![undefined, null].includes(loanRequestId)) {
      getAmortizationSchedule(loanRequestId)
        .then((res) => {
          setResponseLoading(false);
          setAmortizationSchedule(res);
        })
        .catch((err) => {
          setResponseLoading(false);
        });
      getRepaymentSchedule(loanRequestId)
        .then((res) => {
          setResponseLoading(false);
          setRepaymentSchedule(res);
        })
        .catch((err) => {
          setResponseLoading(false);
        });
    }
  }, [loanRequestId]);

  const principalPaid = ![undefined, null].includes(repaymentSchedule)
    ? repaymentSchedule
        .map((_) => _.principal)
        .reduce((accumulator, currentValue) => {
          return accumulator + currentValue;
        }, 0)
    : 0;

  return (
    <LoaderWrapper isLoading={responseLoading}>
      <Formik
        initialValues={{}}
        onSubmit={onFormSubmit}
        enableReinitialize
        validateOnChange={false}
        validateOnBlur={false}
      >
        {({
          handleChange,
          setFieldValue,
          handleSubmit,
          setValues,
          values,
          errors,
          ...rest
        }) => {
          const fieldValues =
            !isEmpty(loanDataFromAPI) && loanRequestId
              ? loanDataFromAPI
              : loanDataFromState;

          const isModified = [
            "RefinancingRequestAwaitingApproval",
            "ReAmortizationRequestAwaitingApproval",
          ].includes(loanStatus);

          return (
            fieldValues && (
              <Form onSubmit={handleSubmit}>
                <ManageDistributionLayout
                  buttons={
                    fromPage == 1 || fromPage == 5
                      ? buttonsForApprovalFlow
                      : !isEmpty(loanDataFromState)
                      ? buttonsForInprogress
                      : loanStatus == "Suspended"
                      ? buttonsForSuspendedLoan
                      : loanStatus == "Active"
                      ? buttonsForActiveLoan
                      : isModified
                      ? buttonsForModifiedLoan
                      : buttonsForAwatingForApproval
                  }
                  layoutHeader="Loan Summary"
                  isLoanSummary={true}
                  blockNavigation={true}
                  employeeImage={employeeImage}
                >
                  {!isModified ? (
                    <LoanSummaryDetails
                      requestId={requestId}
                      keyValue={keyValue}
                      paymentMethod={paymentMethod}
                      tabChange={tabChange}
                      fieldValues={fieldValues}
                      loanData={loanData}
                      planData={planData}
                      loanSettingInfo={loanSettingInfo}
                      filteredValues={filteredValues}
                      loanDataFromState={loanDataFromState}
                      FieldInputCheck={FieldInputCheck}
                      checkBox={checkBox}
                      setSliderOpen1={setSliderOpen1}
                      setSliderOpen2={setSliderOpen2}
                      errors={errors}
                      today={today}
                      loanStatus={loanStatus}
                      sourceSplit={sourceSplit}
                      sourceSplitData={sourceSplitData}
                      calculateTotalFees={calculateTotalFees}
                      calculateNetAmount={calculateNetAmount}
                      setModifyFor={setModifyFor}
                      principalPaid={principalPaid}
                      isModified={isModified}
                      showClose={showClose}
                      setShowClose={setShowClose}
                      setResponseLoading={setResponseLoading}
                      amortizationSchedule={amortizationSchedule}
                      repaymentSchedule={repaymentSchedule}
                    />
                  ) : (
                    <LoanModifySummary
                      keyValue={keyValue}
                      paymentMethod={paymentMethod}
                      tabChange={tabChange}
                      fieldValues={fieldValues}
                      loanData={loanData}
                      planData={planData}
                      loanSettingInfo={loanSettingInfo}
                      filteredValues={filteredValues}
                      loanDataFromState={loanDataFromState}
                      FieldInputCheck={FieldInputCheck}
                      checkBox={checkBox}
                      setSliderOpen1={setSliderOpen1}
                      errors={errors}
                      today={today}
                      loanStatus={loanStatus}
                      showClose={showClose}
                      setShowClose={setShowClose}
                      principalPaid={principalPaid}
                      sourceSplit={sourceSplit}
                      sourceSplitData={sourceSplitData}
                      calculateTotalFees={calculateTotalFees}
                      calculateNetAmount={calculateNetAmount}
                      isModified={isModified}
                      setModifyFor={setModifyFor}
                      setSliderOpen2={setSliderOpen2}
                      fromApproval={false}
                    />
                  )}
                  <SliderPanel
                    isOpen={sliderOpen1}
                    size="35"
                    onClose={() => setSliderOpen1(false)}
                    showCancel={true}
                    backdropClicked={() => setSliderOpen1(false)}
                  >
                    <div className="disp-flex-col">
                      <div
                        className="disp-flex-row"
                        style={{
                          justifyContent: "space-between",
                          fontWeight: "500",
                          fontSize: "16px",
                          borderBottom: "1px solid #BDBDBD",
                        }}
                      >
                        <p
                          style={{
                            fontSize: "16px",
                            fontWeight: "500",
                            marginBottom: "20px",
                          }}
                        >
                          Terms & Conditions
                        </p>
                      </div>
                      <ul style={{ marginTop: "15px" }}>
                        <li>
                          I have read and understood all the rules governing
                          loan requests from my 401k plan.
                        </li>
                        <li>
                          I understand that redemption fees may be imposed on
                          certain funds if assets are held less than the period
                          stated in the fund’s prospectus or other disclosure
                          documents.
                        </li>
                        <li>
                          I understand that it is entirely my responsibility to
                          ensure that this election conforms with all applicable
                          provisions of the Internal Revenue Code.
                        </li>
                        <li>
                          I understand that I may be liable for any income tax
                          and/or penalties assessed by the IRS for any elections
                          I have chosen.
                        </li>
                        <li>
                          I understand that once my payment has been processed,
                          it cannot be changed.
                        </li>
                      </ul>
                    </div>
                  </SliderPanel>
                  <WarningModal
                    show={modalVisible}
                    onHide={() => setModalVisible(false)}
                  >
                    <div className="remove-text">
                      <h4>
                        Are you sure you want to delete the{" "}
                        {loanStatus == "RefinancingRequestAwaitingApproval"
                          ? "Refinancing"
                          : "Reamoritze"}{" "}
                        request for {loanData.loanType} -{" "}
                        {loanData.loanIdentifier} ?
                      </h4>
                      <Button
                        className="remove-btn mr-4"
                        onClick={() => {
                          setModalVisible(false);
                          setSliderOpen2(false);
                          rejectLoan({
                            loanId: loanRequestId,
                            comments: "Deleted",
                          }).then((_) => {
                            setTrigger(!trigger);
                          });
                        }}
                      >
                        Delete
                      </Button>

                      <Button
                        className="cancel-btn"
                        onClick={() => setModalVisible(false)}
                      >
                        Cancel
                      </Button>
                    </div>
                  </WarningModal>
                  <SliderPanel
                    isOpen={sliderOpen2}
                    size={modifyFor == "suspend" ? "60" : "95"}
                    showCancel={false}
                    backdropClicked={() => setSliderOpen2(false)}
                  >
                    {modifyFor != "suspend" ? (
                      <LoanSummarySlider
                        setSliderOpen2={setSliderOpen2}
                        modifyFor={modifyFor}
                        loanData={loanData}
                        planData={planData}
                        principalPaid={principalPaid}
                        loanSettingInfo={loanSettingInfo}
                        employeeInfo={filteredValues}
                        setTrigger={setTrigger}
                        trigger={trigger}
                        calculateTotalNoOfInstallments={
                          calculateTotalNoOfInstallments
                        }
                        repaymentSchedule={repaymentSchedule}
                        loanStatus={loanStatus}
                      />
                    ) : (
                      <LoanSuspensionRequest
                        setLoanSuspensionSlider={setSliderOpen2}
                        loanData={loanData}
                        planData={planData}
                        loanStatus={loanStatus}
                        principalPaid={principalPaid}
                        loanSettingInfo={loanSettingInfo}
                        employeeInfo={filteredValues}
                        calculateTotalNoOfInstallments={
                          calculateTotalNoOfInstallments
                        }
                        setTrigger={setTrigger}
                        trigger={trigger}
                        showClose={showClose}
                        setShowClose={setShowClose}
                      />
                    )}
                  </SliderPanel>
                </ManageDistributionLayout>
              </Form>
            )
          );
        }}
      </Formik>
    </LoaderWrapper>
  );
};
export default LoanSummaryContainer;
